var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nation"},[_c('img',{staticClass:"nation_icon",attrs:{"src":_vm.content.nationPath,"alt":""},on:{"click":_vm.itemClick}}),_c('div',[_vm._v(_vm._s(_vm.content.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }